import { render, staticRenderFns } from "./Response.vue?vue&type=template&id=2897f353&scoped=true&"
import script from "./Response.vue?vue&type=script&lang=js&"
export * from "./Response.vue?vue&type=script&lang=js&"
import style0 from "./Response.vue?vue&type=style&index=0&id=2897f353&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2897f353",
  null
  
)

export default component.exports